import React, { useState, useEffect } from "react";

import correctAudio from "../../assets/sounds/correct_answer.mp3";
import incorrectAudio from "../../assets/sounds/wrong_answer.mp3";

const ImageMCQComponent = ({ questionData, onOptionClick }) => {
  const { questionimagelist, imageList,answer,questionaudio } = questionData;
  const [selectedIndex, setSelectedIndex] = useState(null);

  const correctSound = new Audio(correctAudio);
  const incorrectSound = new Audio(incorrectAudio);

  useEffect(() => {
      let audio = null;
  
      if (questionaudio) {
        audio = new Audio(questionaudio);
        audio.loop = false;
        audio.volume = 0.5; 
  
        audio
          .play()
          .then(() => {
            console.log("Background audio started playing");
          })
          .catch((error) => {
            console.error("Error playing background audio:", error);
          });
      }
        return () => {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
      };
    }, [questionaudio]);
  useEffect(() => {
    setSelectedIndex(null);
  }, [questionData]);

  const handleOptionClick = (index) => {
    setSelectedIndex(index);
    onOptionClick(index);
        if (answer[0] === index) {
      correctSound.play();
    } else {
      incorrectSound.play();
    }
  };

  return (
    <div className="select-num-component flex flex-col items-center gap-[50px]">
      {questionimagelist && (
        <img className="w-[35%]" src={questionimagelist} alt="Question" />
      )}
      <div className="option-list flex">
        {imageList.map((image, index) => (
          <div
            key={index}
            className="relative w-[80px] h-[80px] flex items-center justify-center cursor-pointer m-2 cursor-pointer"
            onClick={() => handleOptionClick(index)}
          >
            {selectedIndex === index && (
              <div className="absolute inset-0 bg-blue-500 opacity-50 rounded-full"></div>
            )}
            <img
              src={image}
              alt={`Option ${index + 1}`}
              className={`w-full h-full object-cover rounded-full transition-opacity duration-300 ${
                selectedIndex === index ? "opacity-50" : "opacity-100"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageMCQComponent;
